import feather from 'feather-icons';
import type { HTMLAttributes } from 'react';

interface Props {
  name: string;
  size?: number;
  title?: string;
  color?: string;
  strokeWidth?: number;
}

export default function Icon({
  name,
  size,
  className,
  title,
  color,
  strokeWidth = 1.5
}: Props & HTMLAttributes<HTMLSpanElement>) {
  const featherString = (feather.icons as Record<string, any>)[name].toSvg({
    class: className,
    width: size || 16,
    height: size || 16,
    'stroke-width': strokeWidth
  });

  return (
    <span
      title={title}
      style={{ display: 'inline-block', lineHeight: 1, color: color }}
      dangerouslySetInnerHTML={{ __html: featherString }}
    />
  );
}
